import  React from 'react';
import TextField from '@mui/material/TextField';
import { sidebarwith } from './Const';

export default function CustomTextField(props) {
    const {label,id,...otherProps} = props
  return (

      <TextField 
        sx={{ width: sidebarwith}}
        {...otherProps}
        fullWidth 
        multiline={true}
        label={label} id={id} 
      />
  );
}

